import React from 'react';
import { Box } from '@components/Box';
import { careersPageData } from '@data-ts/pages/careers';
import { FindYourJoyContent } from './FindYourJoyContent';
import { StyledTextPairingMobile, StyledColumns, StyledColumn } from './FindYourJoy.styles';

export const FindYourJoyMobile: React.FC = () => {
  const findYourJoyData = careersPageData.findYourJoy;
  return (
    <Box marginTop={-9} paddingBottom={10}>
      <StyledColumns>
        <StyledColumn mobile={12}>
          <StyledTextPairingMobile
            title={findYourJoyData.title}
            titleVariant="hed56"
            titleColor={'neutra6'}
            titleTagName="h2"
            body={findYourJoyData.body}
            bodyVariant="dek20"
            bodyColor={'neutra5'}
            bodyTagName="h2"
          />
        </StyledColumn>
      </StyledColumns>
      <FindYourJoyContent id="mobile" />
    </Box>
  );
};
